import {Injectable} from '@angular/core';
import {EstadoRegistroEntity} from './servicio-solicitudes-suministro.service';
import {ReportesRequestService} from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class EntregaMedicamentosService {

  constructor(private requestUrl: ReportesRequestService) {}

  async getInformacionUsuario(codigoBaseDatos: string, unco_login: number) {
    try {
      return await this.requestUrl.getRequest(
        'informacion-usuario/datos',
        [codigoBaseDatos, { unco_login }]
      );
    } catch (e) {
      console.error('EntregaMedicamentosService.getInformacionUsuario() ${e}');
    }
    return null;
  }

  async getEntregaMedicamentosData(codigoBaseDatos: string, ld_fec_ini: Date, ld_fec_fin: Date, uncoAfiliado: number, ln_idntfcdr_bsqda: number) {
    try {
      return await this.requestUrl.getRequest(
        'reporteEntregaMedicamentos/entregaMedicamentos',
        [codigoBaseDatos, {ld_fec_ini, ld_fec_fin, uncoAfiliado, ln_idntfcdr_bsqda}]
      );
    } catch (e) {
      console.error('EntregaMedicamentosService.getEntregaMedicamentosData()', e);
    }
    return null;
  }

  async getTiposDocumentos(codigoBaseDatos: string) {
    try {
      return await this.requestUrl.getFilterRequest(
        'tipos-identificacion/filter-tipos-identificacion',
        [codigoBaseDatos]
      );
    } catch (e) {
      console.error('EntregaMedicamentosService.getEntregaMedicamentosData()', e);
    }
    return null;
  }

  async getAfiliadoByTipoDocAndNumberIdentification(codigoBaseDatos: string, tipoDoc: number, numberIdentification: number) {
    try {
      return await this.requestUrl.getRequest(
        'afiliado/get-afiliado',
        [codigoBaseDatos, {tipoDoc, numberIdentification}]
      );
    } catch (e) {
      console.error('EntregaMedicamentosService.getAfiliadoByTipoDocAndNumberIdentification()', e);
    }
    return null;
  }

  async getAfiliadosByFilter(codigoBaseDatos: string, textFilter: string) {
    try {
      return await this.requestUrl.getRequest(
        'afiliado/get-afiliadoByFilter',
        [codigoBaseDatos, {textFilter}]
      );
    } catch (e) {
      console.error('EntregaMedicamentosService.getEntregaMedicamentosData()', e);
    }
    return null;
  }
}

export interface AfiliadoEntity {
  unco: number;
  uncoTipoDoc: number;
  nmro_idntfccn: number;
  tpo_idntfccn: string;
  nombre: string;
  genero: string;
}

export interface FitlrosEntregaMedicamentosEntity {
  fechaIni: Date;
  fechaFin: Date;
  uncoAfiliado: number;
}

export interface EntregaMedicamentosEntity {
  Unco_afldo_emprsa: number;
  unco_tpo_idntfccn: number;
  Unco_sde_pnto_atncn: number;
  Unco_sde_pnto_atncn_tpo_atncn: number;
  unco_lna_prdcto: number;
  unco_ctlgo_smnstrs_mdcmnts: number;
  unco_prfsnls_sld_ordna: number;
  cnsctvo_dcto: number;
  cdgo_ctlgoSmnstrsMdcmnts: number;
  cntdd: number;

  nmro_idntfccn: string;
  emprsa: string;
  cdgo: string;
  prmr_aplldos: string;
  sgndo_aplldo: string;
  prmr_nmbre: string;
  sgndo_nmbre: string;
  prfjo: string;
  tpo_dcto: string;
  dscrpcn: string;
  sde: string;
  pnto: string;
  dscrpcn_ctlgoSmnstrsMdcmnts: string;
  prfsnlesSld_nmbrs: string;
  prfsnlesSld_apllds: string;

  fcha_dcto: Date;

  estadoRegistroEntity: EstadoRegistroEntity;
}
